import { render } from "./AbortTeaser.vue?vue&type=template&id=5664ee8e&scoped=true"
import script from "./AbortTeaser.vue?vue&type=script&lang=js"
export * from "./AbortTeaser.vue?vue&type=script&lang=js"

import _style_0 from "./AbortTeaser.vue?vue&type=style&index=0&id=5664ee8e&inline&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-5664ee8e"]])

export default __exports__